import axios from 'axios'

export async function uploadApplyFile({ raw, name }, { id }) {
  try {
    let data = new FormData()
    data.append('file', raw)
    data.append('name', name)

    const res = await axios.post(`/api/public/v1/jobs/${id}/apply/file-upload`, data)
    return res.data.data.token
  } catch (e) {
    Notification.error({ message: 'Apply file upload Error', dangerouslyUseHTMLString: true })
    throw e
  }
}
